import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TooltipPosition } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@app/services/app.service';
import { AuthService } from '@app/services/auth.service';
import { HelperService } from '@app/services/helper.service';
import { TranslocoService } from '@jsverse/transloco';


@Component({
  selector: 'app-signup-confirmation',
  standalone: false,
  templateUrl: './signup-confirmation.component.html',
  styleUrls: ['./signup-confirmation.component.scss']
})
export class SignupConfirmationComponent implements OnInit {
  theme!: string;
  themeConfig: any;
  loaded: boolean = false;
  show: boolean = false;
  isMObile!: boolean;
  id!: number;
  userDetails: any;
  loginHost!: string;
  orgIdData!: number;


  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new FormControl(this.positionOptions[0]);

  constructor(
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private appService: AppService,
    private helper: HelperService,
    private translocoService: TranslocoService
  ) { }

  ngOnInit(): void {

    this.appService.themeConfig.subscribe(r => {
      this.themeConfig = r;
      this.theme = 'theme-red';
      this.loaded = true;
      console.log('User Theme From Service:', this.themeConfig);
    });

    let langData = localStorage.getItem('lang');
    if (langData) {
      this.translocoService.setActiveLang(langData);
    } else {
      this.translocoService.setActiveLang('en');
    }

    this.route.params.subscribe((r: any) => {
      if (r.id) {
        this.id = r.id;
        this.getUserDetails();
      }
    })

    /*CHECK HOST OPEN */
    this.loginHost = window.location.host;
    console.log("Location URL", window.location.host);

    /*CHECK HOST CLOSE */


  }

  getUserDetails() {
    this.authService.getUserDetails(this.id).subscribe((r: any) => {
      this.userDetails = r.data;
    }, (err: any) => this.helper.showHttpErrorMsg(err));
  }

  loginPage() {
    this.router.navigate(["/login"]);
  }

  backPage() {
    this.router.navigate(["/signup"]);
  }

  setHeaderBackground(degree = 90, primary = this.themeConfig.bgAndFontColor.login.desktop.bg[0], secondary = this.themeConfig.bgAndFontColor.login.desktop.bg[1]){
    return `linear-gradient(${degree}deg, ${primary}, ${secondary}) !important`;
  }

  setBorder(color: string, isBorder: boolean = this.themeConfig.bgAndFontColor.default.btnBorder){
    if(isBorder){
      return `1px solid ${color} !important`;
    }
    else{
      return ``;
    }
  }

  setBorderRadius(isRadius: boolean, radius = '0px'){
    if(isRadius){
      return '';
    }
    else{
      return radius;
    }
  }

}
